export default __webpack_public_path__ + "static/media/agencies_hero.899b1172.jpeg";